module.exports = __webpack_public_path__ + "img/by-tradeup.8f072768.svg";